module.exports = "pegasus_template/assets/rectoutline-twitter.png";